<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="foreword">
<h2 class="h2a"><span epub:type="pagebreak" id="page_9"><strong>FOREWORD</strong></span></h2>
<p class="imagea"><img alt="Image" class="in100" src="images/bar.jpg"/></p>
<p class="noindent1">I’ve written seventeen cookbooks. Some of my books have taken years to write, with extensive research and many recipes. Others are smaller, single-subject recipe books. My first book <em>From Tapas to Meze</em> was my firstborn and continues to hold me by the heartstrings. My most recent book, <em>Kitchen Gypsy: Recipes and Stories from a Lifelong Romance with Food</em> has been a pure passion project near and dear to my soul. And it’s Grace Parisi I have to thank for bringing me into this most recent project.</p>
<p class="noindent1">Let me back up a little bit! I’ve known Grace for years. At first, it was her sound reputation I knew from her years working at <em>Food &amp; Wine</em> magazine. Like everyone, I held her name with the highest regard. A few years later, I met Grace in person when we worked on a story together for the magazine. She was everything I’d heard—smart and talented.</p>
<p class="noindent1">I hadn’t seen Grace for a while, and then a couple of years ago we sat together at an industry dinner in Chicago.</p>
<p class="noindent1">“You two should do a book together,” Grace said as she generously introduced me to the editor-in-chief at Oxmoor House.</p>
<p class="noindent1">That’s how <em>Kitchen Gypsy</em> began, and what transpired was magical. Grace and I worked closely on my book. She traveled to San Francisco several times to test recipes and style the recipes. As we worked side by side, I marveled at her creativity, patience, perseverance, and genuine congeniality.</p>
<p class="noindent1">What Grace brings to the table every time she jumps into a project is her intelligence, expertise, and passion. Take this book about pickles, for example. Reading the recipes will make you want to run into your kitchen and cook up a batch of Pickled Plum Tomatoes with Chipotle, Spicy Bread-and-Butter Pickles, or Lime-Chile Pickled Pineapple! And that’s what a good cookbook is supposed to do, right?</p>
<p class="noindent1"><strong><span class="f5">JOANNE WEIR</span></strong><br/><em>Chef, teacher, television personality,<br/>and James Beard Award–winning cookbook author</em></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// foreword.vue?7c95d328